import React from 'react'

const MainFooter = () => {
  return (
    <>
      <div className="grow"></div>

      <div className="flex justify-between lg:justify-center lg:gap-16 mt-8 items-center w-screen py-8 px-10 h-10">
        <div className="text-sm text-gray-500">© Copyright Acts</div>

        <div className="flex">
          <a
            href="https://www.facebook.com/profile.php?id=100089265053519&mibwxtid=ZbWKwL"
            target="_blank"
            className="hover:scale-110 transition-all"
          >
            <img
              src="https://i.ibb.co/3fmF4zH/icons8-facebook-48.png"
              alt=""
              className="w-9"
            />
          </a>
          <div className="w-5"></div>
          <a
            href="https://wa.me/message/K5BD6QOI2BBYE1"
            target="_blank"
            className="hover:scale-110 transition-all"
          >
            <img
              src="https://i.ibb.co/k2rf8LM/icons8-whatsapp-48-1.png"
              alt=""
              className="w-9"
            />
          </a>
        </div>
      </div>
    </>
  );
}

export default MainFooter